import React, { useState } from 'react';
import { Table, Tag, Tabs } from 'antd';
import './TradeRoom.css';

const columns = [
  { title: 'Name', dataIndex: 'stockSymbol', key: 'stockSymbol' },
  { title: 'Type', dataIndex: 'type', key: 'type', render: v => v || 'Option' },
  { title: 'Experation', dataIndex: 'expirationTime', key: 'expirationTime', render: v => new Date(v).toLocaleString() },
  { title: 'Innvestment', dataIndex: 'amount', key: 'amount', render: v => `$${v}` },
  { title: 'Open', dataIndex: 'open', key: 'open', render: v => v !== undefined ? v : '-' },
  { title: 'Current price', dataIndex: 'currentPrice', key: 'currentPrice', render: v => v !== undefined ? v : '-' },
  { title: 'Expected rate', dataIndex: 'expectedRate', key: 'expectedRate', render: v => v !== undefined ? v : '-' },
  { title: 'Return after', dataIndex: 'returnAfter', key: 'returnAfter', render: v => v !== undefined ? v : '-' },
  { title: 'Status', dataIndex: 'status', key: 'status', render: v => {
    if (v === 'win') return <Tag color="green">Win</Tag>;
    if (v === 'lose') return <Tag color="red">Lose</Tag>;
    if (v === 'active') return <Tag color="blue">Active</Tag>;
    return <Tag>Pending</Tag>;
  } },
];

const mockLive = [
  { key: 1, stockSymbol: 'BTC/USDT', type: 'Option', expirationTime: Date.now() + 60000, amount: 100, open: 65000, currentPrice: 65100, expectedRate: '86%', returnAfter: '1m', status: 'active' },
];
const mockHistory = [
  { key: 2, stockSymbol: 'ETH/USDT', type: 'Option', expirationTime: Date.now() - 60000, amount: 50, open: 3000, currentPrice: 2990, expectedRate: '86%', returnAfter: '1m', status: 'win' },
];

const TradeHistoryPanel = ({ activeOptions = [] }) => {
  const [tab, setTab] = useState('live');

  // Преобразуем activeOptions к нужному формату (пример)
  const liveData = (activeOptions.length ? activeOptions : mockLive).map((o, i) => ({
    key: o.key || i,
    stockSymbol: o.stockSymbol,
    type: o.type || 'Option',
    expirationTime: o.expirationTime,
    amount: o.amount,
    open: o.open,
    currentPrice: o.currentPrice,
    expectedRate: o.expectedRate || '86%',
    returnAfter: o.returnAfter || '-',
    status: o.status || 'active',
  }));
  const historyData = mockHistory;

  return (
    <div className="trade-history-panel">
      <div className="trade-table-block" style={{ width: '100%' }}>
        <Tabs
          activeKey={tab}
          onChange={setTab}
          items={[
            {
              key: 'live',
              label: 'Live',
              children: (
                <Table
                  columns={columns}
                  dataSource={liveData}
                  pagination={false}
                  size="small"
                  className="trade-table"
                  locale={{ emptyText: 'No live options' }}
                  scroll={{ x: true }}
                />
              ),
            },
            {
              key: 'history',
              label: 'History',
              children: (
                <Table
                  columns={columns}
                  dataSource={historyData}
                  pagination={false}
                  size="small"
                  className="trade-table"
                  locale={{ emptyText: 'No history' }}
                  scroll={{ x: true }}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default TradeHistoryPanel; 